<template>
  <div>
    <TermsCom title="BLUE RIDGE TERMS OF SERVICE" class="pc-doc container"></TermsCom>
  </div>
</template>
<script>
import TermsCom from '../components/termsCom.vue'
export default {
  data() {
    return {
      bannerFixed: false,
    }
  },
  components: {
    TermsCom,
  },
}
</script>
<style lang="scss">
@import '@/styles/public';
.pc-doc {
  padding-bottom: 80px;
  .title {
    text-align: center;
    font-size: 32px;
    font-weight: bold;
    color: $theme-color;
    margin: 0px 0 30px;
  }
  .text {
    line-height: 1.5;
    color: #333;
    margin-bottom: 10px;
  }
  .bold {
    font-weight: bold;
  }
  .s-title {
    color: $theme-color;
    font-size: 24px;
    margin: 30px 0 10px;
    font-weight: bold;
  }
}
</style>
